import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import { Pagination } from "../types";

export const siteLanguagesSection = "/site-languages/";

export const siteLanguageListPath = siteLanguagesSection;

export type SiteLanguageListUrlQueryParams = Pagination;
export const siteLanguageListUrl = (params?: SiteLanguageListUrlQueryParams) =>
  siteLanguageListPath + "?" + stringifyQs(params);

export const siteLanguagePath = (id: string) =>
  urlJoin(siteLanguagesSection, id);
export const siteLanguageUrl = (id: string) =>
  siteLanguagePath(encodeURIComponent(id));
